import React from 'react';
import { FaPhoneSquareAlt, FaEnvelope } from 'react-icons/fa';

import './Registration.css';

function DeleteLeftSidePage() {
    return (
      <div className="reglogo">
        <img className=" client_logo_login_logout" src={process.env.PUBLIC_URL + '/images/ogcrm.png'} alt="clientlogo" />
        <h2>Delete your account</h2>
        <h6>Need assistance deleting your account ?</h6>
        <h6><FaPhoneSquareAlt /> : <a style={{ color: 'white', textDecoration: 'none' }} href="+919136390992">+91 9136390992</a></h6>
        <h6> <FaEnvelope /> : <a style={{ color: 'white', textDecoration: 'none' }} href="mailto:sales@orggen.com">support@orggen.com</a></h6>
      </div>
    );
  }
export default DeleteLeftSidePage;
